// Auto generated file, do not manually modify!
// com.hotpads.yourrentalapi.enums.UpsellCardType

export enum UpsellCardType {
  LEASE_UPSELL = 'LEASE_UPSELL',
  PCR_UPSELL = 'PCR_UPSELL',
  RENTER_INSURANCE_UPSELL = 'RENTER_INSURANCE_UPSELL',
  RENT_PAYMENTS_AND_CREDIT_CLIMB_UPSELL = 'RENT_PAYMENTS_AND_CREDIT_CLIMB_UPSELL',
}

export const UpsellCardType_values = [
  UpsellCardType.LEASE_UPSELL,
  UpsellCardType.PCR_UPSELL,
  UpsellCardType.RENTER_INSURANCE_UPSELL,
  UpsellCardType.RENT_PAYMENTS_AND_CREDIT_CLIMB_UPSELL,
] as const;
